// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"8d129c25","300":"4fe6a81e","306":"97e765ff","412":"3b4db2ec","453":"03fca7ee","504":"13a4efd7","524":"7e3c532d","591":"6bfa955b","773":"9f159313","787":"7fd9a4d3"}[chunkId] + ".chunk.js";
};